import { render } from "./LineWithDataLabelsChart.vue?vue&type=template&id=956c0194"
import script from "./LineWithDataLabelsChart.vue?vue&type=script&lang=js"
export * from "./LineWithDataLabelsChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__